import { DocumentNode } from '@apollo/client';
import getDocumentKey from './getDocumentKey';

type buildQueryKeyOptions = {
  query: DocumentNode;
  variables: Record<string, any>;
};

/**
 * use query name and variables to build a query key to use
 * @param query
 * @param variables
 */
const buildQueryKey = ({ query, variables }: buildQueryKeyOptions) => {
  const key = getDocumentKey(query);
  return [key, { variables }];
};

export default buildQueryKey;
